<template>
  <v-dialog v-model="dialog" width="600" persistent :fullscreen="isMobile">
    <v-card>
      <v-toolbar
        :class="{ 'd-flex align-center': isMobile }"
        :style="{ height: isMobile ? '72px' : '64px' }"
      >
        <div v-if="isMobile" style="font-size: 1.25rem; line-height: 1.5;">
          {{ $route.meta.nameDrawer }}
        </div>
        <v-toolbar-title v-else>{{ $route.meta.nameDrawer }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="pt-10 pb-6" :class="isMobile ? 'px-4' : 'px-6'">
        <div class="mb-2 white--text">{{ $t("searchExemptPlayer") }}</div>
        <AutocompletePlayers />

        <div v-if="linkAffiliateExemptPlayerView">
          <div v-if="linkedExemptPlayer.name" class="mt-6 white--text">
            {{ $t("playerName", { playerName: linkedExemptPlayer.name }) }}
          </div>
          <div v-else style="height: 46px;"></div>
          <div
            v-if="linkedExemptPlayer.name && !linkedExemptPlayer.alreadyLinked"
            class="mt-4 pa-2 d-flex"
            style="background-color: #3c2e1d;"
          >
            <div class="mr-2">
              <v-icon color="#FB8C00">mdi-alert-circle</v-icon>
            </div>

            <div style="color: #fb8c00; font-size: 14px;">
              {{ $t("irreversibleActionExemptPlayer") }}
            </div>
          </div>
          <div v-else style="height: 76px;"></div>
        </div>

        <div
          v-if="!linkAffiliateExemptPlayerView"
          class="mt-4 mb-2 white--text"
        >
          {{ $t("searchAffiliate") }}
        </div>
        <v-autocomplete
          v-if="!linkAffiliateExemptPlayerView"
          v-model="selectedAffiliates"
          :label="$t('searchAffiliate')"
          :no-data-text="$t('autoCompleteNoData')"
          :items="listAffiliates"
          :loading="isLoading"
          :rules="[rules.required]"
          :search-input.sync="searchAffiliate"
          item-text="ui"
          item-value="id"
          :hint="$t('searchAffiliateSpan')"
          persistent-hint
          prepend-icon="mdi-magnify"
          dense
          solo-inverted
          clearable
          return-object
          chips
          multiple
          @click:clear="clearable"
          @paste="onPaste"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span v-if="isMobile">{{ item.name }}</span>
              <span v-else>
                {{ item.name }} ({{ item.login }} {{ item.id }})
              </span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ selectedAffiliates.length - 1 }} {{ $t("others") }})
            </span>
          </template>
        </v-autocomplete>

        <div
          v-if="!linkAffiliateExemptPlayerView"
          class="mt-4 pa-2 d-flex"
          style="background-color: #3c2e1d;"
        >
          <div class="mr-2">
            <v-icon color="#FB8C00">mdi-alert-circle</v-icon>
          </div>

          <div style="color: #fb8c00; font-size: 14px;">
            {{ $t("irreversibleActionExemptPlayer") }}
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pb-6" :class="isMobile ? 'px-4' : 'px-6'">
        <v-spacer></v-spacer>
        <v-btn
          class="black--text"
          color="white"
          depressed
          type="submit"
          :large="isMobile"
          :loading="isLoading"
          :disabled="isLoading"
          @click="closeDialog"
          style="width: 129px; height: 29px;"
        >
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          color="info"
          depressed
          type="submit"
          :large="isMobile"
          :loading="isLoading"
          :disabled="disableBtn || isLoading"
          @click="linkExemptPlayerAffiliates"
          style="width: 129px; height: 29px;"
        >
          {{
            linkedExemptPlayer.name && linkedExemptPlayer.alreadyLinked
              ? "Ok"
              : $t("toSave")
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import AutocompletePlayers from "@/components/common/filters/AutocompletePlayers";
import { validate } from "@/util/validate.js";

export default {
  name: "link-exempt-player",

  components: {
    AutocompletePlayers,
  },

  data: () => ({
    selectedAffiliates: [],
    listAffiliates: [],
    searchAffiliate: "",
    siglaAffiliate: "",
    termAffiliate: "",
    isLoading: false,
    rules: {
      required: validate.required,
    },
    linkAffiliateExemptPlayerView: false,
  }),

  mounted() {
    const adminLinkAffiliateExemptPlayer =
      this.$route.name ===
      "AdministratorOnlineAffiliatesUsersLinkAffiliateExemptPlayer";
    const colabLinkAffiliateExemptPlayer =
      this.$route.name ===
      "CollaboratorAffiliatesUsersLinkAffiliateExemptPlayer";
    const adminLinkExemptPlayerAffiliates =
      this.$route.name ===
      "AdministratorOnlineAffiliatesUsersLinkExemptPlayerAffiliates";
    const colabLinkExemptPlayerAffiliates =
      this.$route.name ===
      "CollaboratorAffiliatesUsersLinkExemptPlayerAffiliates";

    if (adminLinkAffiliateExemptPlayer || colabLinkAffiliateExemptPlayer) {
      this.linkAffiliateExemptPlayerView = true;

      if (!this.dialog) {
        this.$router.push({
          name: adminLinkAffiliateExemptPlayer
            ? "AdministratorAffiliatesAffiliatesList"
            : "CollaboratorAffiliatesAffiliatesList",
        });
      }
    }

    if (
      (adminLinkExemptPlayerAffiliates || colabLinkExemptPlayerAffiliates) &&
      !this.dialog
    ) {
      this.$router.push({
        name: adminLinkExemptPlayerAffiliates
          ? "AdministratorAffiliatesAffiliatesList"
          : "CollaboratorAffiliatesAffiliatesList",
      });
    }
  },

  watch: {
    dialog(val) {
      if (val) {
        this.linkAffiliateExemptPlayerView = false;
      } else {
        this.$router.go(-1);
      }
    },
    searchAffiliate(search) {
      this.onSearchAffiliateChange(search);
    },
    selectedAffiliates(selectedAffiliates) {
      if (selectedAffiliates.length > 0) {
        this.listAffiliates = [...selectedAffiliates, ...this.listAffiliates];
      }
    },
    listAffiliates(listAffiliates) {
      if (listAffiliates.length === 0) {
        this.listAffiliates = this.selectedAffiliates;
      }
    },
    $route(route) {
      if (
        route.name ===
          "AdministratorOnlineAffiliatesUsersLinkAffiliateExemptPlayer" ||
        route.name === "CollaboratorAffiliatesUsersLinkAffiliateExemptPlayer"
      ) {
        this.linkAffiliateExemptPlayerView = true;
      }
    },
  },

  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    autocompletePlayers() {
      return this.$store.state.filters.autocompletePlayers.id;
    },
    disableBtn() {
      // Se for ação de vincular um jogador isento a um afiliado
      // (Já vinculado)
      if (
        this.linkAffiliateExemptPlayerView &&
        this.linkedExemptPlayer.alreadyLinked
      ) {
        return false;
      } else if (this.linkAffiliateExemptPlayerView) {
        // Se for ação de vincular um jogador isento a um afiliado
        // (Ainda não vinculado)
        return !this.autocompletePlayers;
      }
      // Se for o botão de vincular um jogador isento a um ou vários afiliados
      return (
        !this.autocompletePlayers ||
        (this.selectedAffiliates && this.selectedAffiliates.length === 0)
      );
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    linkedExemptPlayer() {
      return this.$store.state.filters.linkedExemptPlayer;
    },
  },

  methods: {
    async searchAffiliates() {
      this.isLoading = true;

      const response = await this.$request.post(
        `${this.$prefix()}/affiliates/searchAffiliate`,
        {
          term: this.termAffiliate,
          has_exempt_player: 0,
        }
      );

      if (response.length == 0) {
        this.listAffiliates = [];
        this.isLoading = false;

        return;
      }

      this.listAffiliates = [
        ...this.selectedAffiliates.map((affiliate) => ({
          ...affiliate,
          nome: affiliate.name,
        })),
        ...response.dados,
      ];

      this.listAffiliates = this.listAffiliates.map((affiliate) => ({
        ui: `${affiliate.nome} (${affiliate.login} ${affiliate.id})`,
        name: affiliate.nome,
        icon: affiliate.online,
        login: affiliate.login,
        id: affiliate.id,
      }));

      this.isLoading = false;
    },
    linkExemptPlayerAffiliates() {
      if (
        this.linkedExemptPlayer.name &&
        this.linkedExemptPlayer.alreadyLinked
      ) {
        this.closeDialog();

        return;
      }

      this.isLoading = true;

      const body = {
        player_id: this.autocompletePlayers,
        affiliates_id: this.$route.params.id
          ? [this.$route.params.id]
          : this.selectedAffiliates.map((affiliate) => affiliate.id),
      };

      this.$axios
        .post(`${this.$prefix()}/affiliates/associateExemptPlayer`, body)
        .then((resp) => {
          this.$store.commit("setFeedbackSnack", {
            msg: resp.data.messages,
            color: "success",
          });
          this.$store.commit("setRefresh", true);

          this.closeDialog();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onSearchAffiliateChange(search) {
      // Caso o usuário selecionar um usuário da lista
      // não permitir realizar o get novamente.
      // O regex abaixo identifica os caracteres "(" e ")"
      // Contido na string e encerra dando return.
      if (/\(|\)/.test(search)) return;

      if (!search) {
        this.siglaAffiliate = "";
        this.termAffiliate = "";
        return;
      }

      if (search == this.siglaAffiliate) return;

      this.siglaAffiliate = search;

      if (search.length >= 3 && search != this.termAffiliate) {
        this.termAffiliate = search;
        this.searchAffiliates();
      }
    },
    onPaste(evt) {
      const copiedText = evt.clipboardData.getData("text");

      if (copiedText && copiedText.trim().length >= 3) {
        this.onSearchAffiliateChange(copiedText);
      }
    },
    clearable() {
      this.listAffiliates = [];
    },
    closeDialog() {
      this.$store.commit("showDialog", false);

      this.$store.commit("setPlayerId", "");
      this.$store.commit("setLinkedExemptPlayer", {
        alreadyLinked: false,
        id: "",
        name: "",
      });

      this.listAffiliates = [];
      this.selectedAffiliates = [];
    },
  },
};
</script>
